import React from 'react'
import style from './Comment.module.sass'
import firebase from '../firebase.js'

class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentComment: '',
            username: '',
            comments: []
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        }

    componentDidMount() {
        const commentsRef = firebase.database().ref('comments');
        commentsRef.on('value', (snapshot) => {
            let comments = snapshot.val();
            let newState = [];
            for (let comment in comments) {
            newState.push({
                id: comment,
                title: comments[comment].title,
                user: comments[comment].user
            });
            }
            this.setState({
            comments: newState
            });
        });
        }
    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        }

    handleSubmit(e) {
        e.preventDefault();
        const commentsRef = firebase.database().ref('comments');
        const comment = {
            title: this.state.currentComment,
            user: this.state.username
        }
        commentsRef.push(comment);
        this.setState({
            currentComment: '',
            username: ''
        });
        }
        
    
    render() {
        return (
            <div className = {`${style.commentContainer} main`}>
            <form onSubmit={this.handleSubmit} className = {style.typeBoxContainer}>

                <div className = {style.promptContainer}>
                <div className = {`${style.prompt} commentPrompt`}>LEAVE A COMMENT</div>
                <div className = {`${style.underline} commentUnderline`}></div>
                </div>
                
                <input className = {`${style.typeBoxUser} typeBox`} name="username" placeholder="What's your name?" onChange={this.handleChange} value={this.state.username} />
                
                <div className = {style.typeBoxCommentContainer}>
                    <textarea  className = {`${style.typeBoxComment} typeBox`}type="text" name="currentComment" placeholder="Sharing is caring. How do you feel about period stigma? Do you have a period story? What do you think about the website? Type here and your comment will appear below…" onChange={this.handleChange} value={this.state.currentComment}></textarea>
                    <button type="submit" value="Submit" className = {`${style.submitButton} submitButton`}>                  
                    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 63.581 63.581">
                    <g id="Group_10" data-name="Group 10" transform="translate(-1515 -5482)">
                        <g className = "submitColor" id="Ellipse_34" data-name="Ellipse 34" transform="translate(1515 5482)" fill="none" stroke-width="2">
                        <circle cx="31.791" cy="31.791" r="31.791" stroke="none"/>
                        <circle cx="31.791" cy="31.791" r="30.791" fill="none"/>
                        </g>
                        <line className = "submitColor"  id="Line_47" data-name="Line 47" x2="34.431" y2="0.415" transform="translate(1530.069 5514.085)" fill="none" stroke-width="2"/>
                        <path className = "submitColor"  id="Path_47" data-name="Path 47" d="M-.4,44.238l-.11-12.582L-.7,10.685" transform="translate(1547.49 5487.218)" fill="none" stroke-width="2"/>
                    </g>
                    </svg>
                </button>
                </div>
            </form>

            <div  className = {`${style.userCommentContainer} userCommentContainer`}>
                    {this.state.comments.slice(0).reverse().map((comment, i) => {
                    return (
                        <div key={comment.id} className = {`${style.userCommentWrapper} userCommentWrapper ${i%2 === 0 && `greyBackground`}`}>
                            <div className = {`${style.userName} userName`} >{comment.user} : </div>
                            <div className = {`${style.commentTitle} commentTitle`}>{comment.title}</div>
                        </div>
                    )
                })}

            </div>
            
        </div>

        )
    }

}
export default Comment